import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ViewMoreButon from "./ViewMore";
import styles from "./CategoryDescription.css";
import CategoryHeaderLinks from "../CategoryHeaderLinks";

const renderWithNoDescription = hasHeaderLinks =>
  hasHeaderLinks ? (
    <div className={styles.expanded}>
      <CategoryHeaderLinks />
    </div>
  ) : null;

const CategoryDescription = ({
  viewport,
  description,
  hasHeaderLinks,
  formatTranslation,
  analyticsClickMoreMvt
}) => {
  if (!description) {
    return renderWithNoDescription(hasHeaderLinks);
  }

  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    setExpanded(false);
  }, [viewport]);

  useEffect(() => {
    expanded && analyticsClickMoreMvt();
  }, [expanded]);

  const memoizedSetExpanded = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  return (
    <div className={styles.categoryDescription}>
      <div
        className={classnames(styles.overflowFade, {
          [styles.expanded]: expanded
        })}
      >
        <div>
          <p className={styles.description}>{description}</p>
        </div>

        <div className={styles.viewMoreWrapper}>
          <ViewMoreButon
            expanded={expanded}
            formatTranslation={formatTranslation}
            onButtonClick={memoizedSetExpanded}
          />
        </div>
      </div>
      {hasHeaderLinks ? <CategoryHeaderLinks /> : null}
    </div>
  );
};

CategoryDescription.propTypes = {
  description: PropTypes.string,
  hasHeaderLinks: PropTypes.bool.isRequired,
  viewport: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  analyticsClickMoreMvt: PropTypes.func.isRequired
};

export default CategoryDescription;
